
export function getEventCategory(event) {
    switch (event.type) {
        case "challenge":
            return 'Fim do desafio';
        case "theme":
            return 'Tema';
        case "studying":
            return 'Horário de Estudo';
        case "module":
            return 'Módulo';
        case "cycle":
            return 'Ciclo';
        default:
            return 'Geral';
    }
}

export function getEventColor(event) {
    switch (event.type) {
        case "challenge":
            return 'nitro';
        case "theme":
            return 'theme';
        case "cycle":
            return '#767676';
        case "studying":
            return 'theme';
        case "module":
            return 'module';
        default:
            return '#767676';
    }
}

export function showEvent ({ nativeEvent, event }) {
    const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => {
            this.selectedOpen = true
        }, 10)
    }

    if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
    } else {
        open()
    }

    nativeEvent.stopPropagation()
}

export function intervalFormat(interval) {
    return interval.time
}

export const types = ['month', 'week', 'day'];

import colors from "../../constants/colors";

export const data = {
    types,
    mode: 'stack',
    modes: ['stack', 'column'],
    weekday: [0, 1, 2, 3, 4, 5, 6],
    value: '',
    colors,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: true,
}
